import { Component } from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-akustische-reaktion-epilog',
	templateUrl: './akustische-reaktion-epilog.component.html',
	styleUrls: ['./akustische-reaktion-epilog.component.scss']
})
export class AkustischeReaktionEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<ReadonlyMap<number, number>>) {}
}
